class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.wrapper = this.querySelector('.cart-notification-wrapper');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.onNotificationClick = this.handleNotificationClick.bind(this);

    if (!this.notification) return;

    this.notification.addEventListener('keyup', (event) => event.code === 'Escape' && this.close());
    this.notification.addEventListener('click', this.onNotificationClick);
  }

  open() {
    if (!this.notification) return;

    this.wrapper?.classList.add('active');
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        if (!this.notification.classList.contains('active')) return;
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    if (!this.notification) return;

    this.notification.classList.remove('active');
    this.wrapper?.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState, options = {}) {
    const shouldOpen = options.open !== false;
    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      if (!target || !parsedState.sections?.[section.id]) return;

      target.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector,
        section.returnOuterHTML
      );
    });

    this.header?.reveal();
    if (shouldOpen) this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
        returnOuterHTML: true,
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section', returnOuterHTML = false) {
    const element = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (!element) return '';
    return returnOuterHTML ? element.outerHTML : element.innerHTML;
  }

  handleBodyClick(event) {
    if (!event.isTrusted) return;

    const target = event.target;
    if (!target.closest('#cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : this.activeElement;
      this.close();
    }
  }

  handleNotificationClick(event) {
    if (!event.target.closest('[data-cart-notification-close]')) return;

    event.preventDefault();
    this.close();
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
